import { FaCalendarAlt } from "react-icons/fa"
import { FaWrench } from "react-icons/fa6"

export const ActionButtonSection = ({ setOpenTakenModal, setOpenRescheduleModal, setOpenUpdateProgressModal }) => {
    return (
        <div className="grid grid-cols-2 gap-3 mt-4">
            <button
                type="button"
                onClick={() => setOpenTakenModal(true)}
                className="group relative w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-bold text-white bg-gradient-to-r from-cyan-600 to-cyan-500 hover:from-cyan-500 hover:to-cyan-400 shadow-lg shadow-cyan-900/30 border border-cyan-400/20 transition-all duration-200 active:scale-[0.98]"
            >
                <FaWrench className="text-base group-hover:rotate-12 transition-transform duration-300" />
                <span>Ambil Tiket</span>

                {/* Efek Kilau Subtle (Shine Effect) */}
                <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 pointer-events-none" />
            </button>

            {/* Tombol 1: Update Pengerjaan (Cyan - Primary Action) */}
            {/* <button
                type="button"
                onClick={() => setOpenUpdateProgressModal(true)}
                className="group relative w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-bold text-white bg-gradient-to-r from-cyan-600 to-cyan-500 hover:from-cyan-500 hover:to-cyan-400 shadow-lg shadow-cyan-900/30 border border-cyan-400/20 transition-all duration-200 active:scale-[0.98]"
            >
                <FaWrench className="text-base group-hover:rotate-12 transition-transform duration-300" />
                <span>Update Progress</span>
                <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 pointer-events-none" />
            </button> */}

            {/* Tombol 2: Jadwalkan Ulang (Amber - Secondary/Date Action) */}
            <button
                type="button"
                onClick={() => setOpenRescheduleModal(true)}
                className="group relative w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-bold text-white bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-500 hover:to-amber-400 shadow-lg shadow-amber-900/30 border border-amber-400/20 transition-all duration-200 active:scale-[0.98]"
            >
                <FaCalendarAlt className="text-base group-hover:scale-110 transition-transform duration-300" />
                <span>Jadwal Ulang</span>

                {/* Efek Kilau Subtle (Shine Effect) */}
                <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 pointer-events-none" />
            </button>
        </div>
    )
}